import MainKPWrapper from "../../components/live2/kp/MainKPWrapper";
import { configKp } from "../../constant/initDrawing";

const Live2KPPage = () => <MainKPWrapper config={configKp} />

export default Live2KPPage;